<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        
        <Detail :header="header" :values="values" @edit="edit"/>
        <TabMenu :model="nestedRouteItems" />
        <router-view v-if="quotation" :quotation="quotation" />
          
      </div>
    </div>
    <QuotationForm
      :quotationDialog="quotationDialog"
      :active="false"
      :quoteToEdit="quotation"
      :disabledArr="disabledArr"
      @close="close"
      @saved="saved"
    />
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";

import Detail from "@/mbp/universalComponents/Detail.vue";

import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";
import BreadcrumbRecordMixin from '../BreadcrumbRecordMixin'

export default {
  mixins: [BreadcrumbRecordMixin],
  computed: {
    breadcrumbRecordLabel() {
      // Quote number with its version, as the lists show it (Q55481-1): a quote number
      // alone does not say which version the crumb belongs to.
      if (!this.quotation || !this.quotation.sQuoteNo) return ''
      return this.quotation.versionNo
        ? `${this.quotation.sQuoteNo}-${this.quotation.versionNo}`
        : this.quotation.sQuoteNo
    }
  },
  components: {
    Detail,
    QuotationForm
  },
  data() {
    return {
      quotationService: new QuotationService,
      header: "Quotation Details",
      nestedRouteItems: [
        {
          label: "Info",
          icon: 'pi pi-info-circle',
          to: `/quotations/${this.$route.params.quoteVerId}/detail`,
        },
        {
          label: "Quotations",
          icon: 'pi pi-money-bill',
          to: `/quotations/${this.$route.params.quoteVerId}/versions`,
        },
        {
          label: "Activities",
          icon: 'pi pi-calendar',
          to: `/quotations/${this.$route.params.quoteVerId}/activities`,
        },
        {
          label: "Attachments",
          icon: 'pi pi-file',
          to: `/quotations/${this.$route.params.quoteVerId}/attachments`,
        },
        {
          label: "History",
          icon: 'pi pi-inbox',
          to: `/quotations/${this.$route.params.quoteVerId}/history`,
        }
      ],
      quotation: {},
      quotationVersions: [],
      quotationActivities: [],
      quotationAttachments: [],
      quotationDialog: false,
      values: [],
      disabledArr: [],
    };
  },
  created() {
    this.getQuotation(this.$route.params.quoteVerId)
  },
  watch: {
    quotationAttachments(val) {
      if (val && val[0]) {
        this.$store.dispatch('quotations/setQuoteAttachmentsForTab', val)
      }
    },
    quotationActivities(val) {
      if (val && val[0]) {
        this.$store.dispatch('quotations/setQuoteActivitiesForTab', val)
      }
    },
    quotationVersions(val) {
      if (val && val[0]) {
        this.$store.dispatch('quotations/setQuoteVersionsForTab', val)
      }
    },
    quotation(val) {
      
      if (val) {
        this.$store.dispatch('quotations/setQuoteForTabs', val)
        this.getQuotationVersions(val.sQuoteNo, val.opportunity && val.opportunity.oppId)  //should be replaced to this.$route.params.quoteVerId
        this.getQuotationActivities(val.quoteVerId)  //should be replaced to this.$route.params.quoteVerId
        this.getQuotationAttachments(val.quoteVerId)  //should be replaced to this.$route.params.quoteVerId
        this.getQuotationHistory(val.quoteVerId)  //should be replaced to this.$route.params.quoteVerId
        let description = '', status = ''
        if (val.quoteStatus && val.quoteStatus.statusName) {
          status = val.quoteStatus.statusName
        }
        if (val.opportunity && val.opportunity.oppDescription) {
          description = val.opportunity.oppDescription
        }
        if (val.versionNo) {
          description = description.concat(` [Version: ${val.versionNo}]`)
        }
        this.values = [
          {
            title: "QuoteNo:",
            description: val.sQuoteNo
          },
          {
            title: "Description",
            description: description
          },
          {
            title: "Status:",
            description: status
          },
          null
        ]
      }
    }
  },
  methods: {
    saved({ quote, file, params, active }) {
      
      this.quotationDialog = false
      this.getQuotation(this.$route.params.quoteVerId)
    },
    close() {
      this.quotationDialog = false
    },
    edit() {
      this.quotationDialog = true;
    },
    getQuotationHistory(quoteVerId) {
      this.quotationService
        .getQuotationHistory(quoteVerId)
        .then(data => this.$store.dispatch('quotations/setQuoteHistoryForTab', data))
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation attachments",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "recordHistoryQuote/{quoteVerId}"'
          })
        })
    },
    getQuotationAttachments(quoteVerId) {
      this.quotationService
        .getQuotationAttachments(quoteVerId)
        .then(data => this.quotationAttachments = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation attachments",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationattachments/{quoteVerId}"'
          })
        })
    },
    getQuotationActivities(quoteVerId) {
      this.quotationService
        .getQuotationActivities(quoteVerId)
        .then(data => this.quotationActivities = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation activities",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationactivities/{quoteVerId}"'
          })
        })
    },
    getQuotationVersions(sQuoteNo, oppId) {
      this.quotationService
        .getQuotationVersions(sQuoteNo, oppId)
        .then(data => this.quotationVersions = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation versions",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationversions/{sQuoteNo}"'
          })
        })
    },
    getQuotation(quoteVerId) {
      this.quotationService
        .getQuotationInfo(quoteVerId)
        .then(data => this.quotation = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationinfo/{quoteVerId}"'
          })
        })
    }
  }
}
</script>

<style>

</style>